import React from "react";
import JCSPAY from "../Assets/jcspay.jpg";

const JPay = () => {
  const handlePayment = () => {
    window.open("https://jcspay.com/", "_blank"); // Open JCSPay in a new tab
  };

  return (
    <div className="flex flex-col md:flex-row items-center pt-16 md:pt-28 justify-center min-h-[60vh] bg-gradient-to-r from-gray-50 to-gray-100 px-6 md:px-16 py-6 md:gap-12">
      
      {/* Left Side - Image (60% width on large screens) */}
      <div className="w-full md:w-2/4 flex justify-center mb-6 md:mb-0">
        <img 
          src={JCSPAY} 
          alt="JCS Global Overview" 
          className="w-full md:w-[60vw] rounded-lg shadow-lg  transition-transform duration-300"
        />
      </div>

      {/* Right Side - Content */}
      <div className="w-full md:w-2/5 text-center md:text-left">
        <h2 className="text-3xl md:text-4xl font-inter text-gray-800">JCSPay - Secure Payment Gateway</h2>
        <p className="mt-4 text-gray-600 text-lg leading-relaxed">
          JCSPay is a fast, secure, and reliable payment gateway designed for seamless transactions. 
          Whether you're shopping online or making business payments, JCSPay ensures safety with 
          encrypted transactions and quick processing.
        </p>
        
        {/* Payment Button */}
        <button 
          onClick={handlePayment} 
          className="mt-6 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 hover:scale-105 transition-transform duration-300"
        >
          Explore JCSPay
        </button>
      </div>

    </div>
  );
};

export default JPay;
